import { BusinessState, DeliveryPeriodType, UiState } from '../../../models';
import { updateShopsWithNowDeliveryPeriod } from '../update-shops-with-new-selected-delivery-period/update-shops-with-now-delivery-period';
import { updateUiDeliveryState } from '../update-ui-delivery-state';

export function preSelectNowDeliveryPeriodBusiness(
  state: BusinessState,
): BusinessState {
  return {
    ...state,
    deliveryPeriods: updateShopsWithNowDeliveryPeriod(state.deliveryPeriods),
  };
}

export function preSelectNowDeliveryPeriodUi(state: UiState): UiState {
  return {
    ...updateUiDeliveryState(state, DeliveryPeriodType.Now),
  };
}
